"use client";

import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const LeftSidebar = ({ toggleActive }) => {
  const location = useLocation(); // Use `useLocation` to get the current path
  const pathname = location.pathname; // Extract `pathname` from location

  // Enable the dark sidebar exclusively for the /dashboard/beauty-salon/ page URL.
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Only check or set the theme if we're on the beauty-salon page.
    if (pathname === "/dashboard/beauty-salon") {
      const storedTheme = localStorage.getItem("beautySalonSidebarTheme");
      if (storedTheme) {
        setIsDark(storedTheme === "dark");
      } else {
        // Default to dark theme and persist it in localStorage
        setIsDark(true);
        localStorage.setItem("beautySalonSidebarTheme", "dark");
      }
    } else {
      // For other pages, do not use localStorage for the theme
      setIsDark(false);
    }
  }, [pathname]);

  return (
    <> 
      <div className={`sidebar-area ${pathname === "/dashboard/beauty-salon" && isDark ? "dark" : ""}`}>
        <div className="logo position-relative">
          <Link
            to="/dashboard/mydashboard"
            className="d-block text-decoration-none position-relative"
          >
            <img
              src="/images/logo-icon.png"
              alt="logo-icon"
              width={26}
              height={26}
            />
            <span className="logo-text fw-bold text-dark">Time Sync</span>
          </Link>
          <button
            className="sidebar-burger-menu bg-transparent p-0 border-0 opacity-0 z-n1 position-absolute top-50 end-0 translate-middle-y"
            onClick={toggleActive}
          >
            <i className="material-symbols-outlined fs-24">close</i>
          </button>
        </div>

        <div className="sidebar-menu">
          <div className="menu-title small text-uppercase">
            <span className="menu-title-text">MAIN</span>
          </div>

          <Accordion defaultActiveKey="0" flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <i className="material-symbols-outlined">dashboard</i>
                <span className="title">Dashboard</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="sub-menu">
                  <li className="menu-item">
                    <Link
                      to="/dashboard/mydashboard"
                      className={`menu-link ${
                        pathname === "/dashboard/mydashboard" ? "active" : ""
                      }`}
                    >
                      My Dashboard
                    </Link>
                  </li>

                  <li className="menu-item">
                    <Link
                      to="/dashboard/myteam"
                      className={`menu-link ${
                        pathname === "/dashboard/myteam" ? "active" : ""
                      }`}
                    >
                      My Team
                    </Link>
                  </li>

                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <i className="material-symbols-outlined">note_stack</i>
                <span className="title">Workspace</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="sub-menu">
                  <li className="menu-item">
                    <Link to="/dashboard/workspaces" className="menu-link ${path">
                      Create Workspaces
                    </Link>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <i className="material-symbols-outlined">groups</i>
                <span className="title">Members</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="sub-menu">
                  <li className="menu-item">
                    <Link to="/dashboard/members" className="menu-link ${path">
                      Add Members
                    </Link>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <i className="material-symbols-outlined">folder</i>
                <span className="title">Reports</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="sub-menu">
                  <li className="menu-item">
                     <Link to="/dashboard/reports" className="menu-link ${path">
                      Team Reports
                    </Link>
                  </li>

                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>
                <i className="material-symbols-outlined">folder</i>
                <span className="title">Screenshot Gallery</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="sub-menu">
                  <li className="menu-item">
                     <Link to="/dashboard/screenshots" className="menu-link ${path">
                      Gallery
                    </Link>
                  </li>

                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5">
              <Accordion.Header>
                <i className="material-symbols-outlined">settings</i>
                <span className="title">Settings</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="sub-menu">
                  <li className="menu-item">
                     <Link to="/dashboard/settings" className="menu-link ${path">
                      Workspace Settings
                    </Link>
                  </li>

                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6">
              <Accordion.Header>
                <i className="material-symbols-outlined">receipt</i>
                <span className="title">Billing</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="sub-menu">
                  <li className="menu-item">
                     <Link to="/dashboard/billing" className="menu-link ${path">
                      Billing Plans
                    </Link>
                  </li>

                </ul>
              </Accordion.Body>
            </Accordion.Item>


            <div className="menu-item">
              <a
                href="/authentication/logout"
                className={`menu-link ${
                  pathname === "/authentication/logout" ? "active" : ""
                }`}
              >
                <i className="material-symbols-outlined">logout</i>
                <span className="title">Logout</span>
              </a>
            </div>
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default LeftSidebar;
